import * as React from 'react';

/* humanize an array:
 *
 * <HumanArray sample={['Sam', 'John', 'Smith']} total={100} />
 *    => Sam, John, Smith and 97 more
 *
 * const array = ['Sam', 'John', 'Smith', 'Doc'];
 * <HumanArray sample={array} total={array.length} />
 *    => Sam, John, Smith and 1 more
 */

type Props = {
  sample: React.ReactNode[];
  total: number;
};

export default function HumanArray(props: Props) {
  const { sample, total } = props;

  if (sample.length === 0) {
    return <span />;
  }

  if (sample.length === 1) {
    return <span>{sample[0]}</span>;
  }

  if (sample.length === 2) {
    return (
      <span>
        {sample[0]} & {sample[1]}
      </span>
    );
  }

  if (sample.length > 2) {
    return (
      <span>
        {sample[0]}, {sample[1]} & {total - 2} more
      </span>
    );
  }

  return null;
}
